import React, { useState } from 'react';
import { X } from 'lucide-react';
import { AuthModal } from './Auth/AuthModal';

interface AuthPromptProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AuthPrompt: React.FC<AuthPromptProps> = ({ isOpen, onClose }) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');

  if (!isOpen) return null;

  const handleAuthOpen = (mode: 'login' | 'signup') => {
    setAuthMode(mode);
    setIsAuthModalOpen(true);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
        <div className="relative bg-white rounded-3xl w-full max-w-sm sm:max-w-md p-6 sm:p-8 text-center shadow-xl">
          <button
            onClick={onClose}
            className="absolute right-3 top-3 p-2 hover:bg-gray-100 rounded-full"
          >
            <X size={20} />
          </button>
          <h2 className="text-xl font-semibold mb-4">Трэба аўтарызацыя</h2>
          <p className="mb-6 text-gray-700">
            Каб дадаць лакацыю, неабходна ўвайсці ў сістэму або зарэгістравацца.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => handleAuthOpen('login')}
              className="flex-1 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
            >
              Увайсці
            </button>
            <button
              onClick={() => handleAuthOpen('signup')}
              className="flex-1 px-4 py-2 border-2 border-primary text-primary rounded-lg hover:bg-primary/5"
            >
              Зарэгістравацца
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
            >
              Адмена
            </button>
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => {
          setIsAuthModalOpen(false);
          onClose();
        }}
        initialMode={authMode}
      />
    </>
  );
};

